/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookResponse } from '../../models/address-book-response';
import { BaseResponse } from '../../models/base-response';

export interface AddressBookControllerGetAll$Params {
  query?: string;
  limit: number;
  skip: number;
}

export function addressBookControllerGetAll(http: HttpClient, rootUrl: string, params: AddressBookControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, addressBookControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookResponse;
      }>;
    })
  );
}

addressBookControllerGetAll.PATH = '/address-book';
